import { FC, createContext } from 'react'

import data from '../content/pages/blog.json'

export interface Top {
    title: string;
    description: string;
    details?: string;
    note?: string;
}

export interface Item {
    title: string;
    description: string;
    link: string;
    date: string;
    tag: string;
    external: boolean;
    sortID: number;

    post_image?: string,
    author?: string;
    author_title?: string;
    author_description?: string;
    author_image?: string;
}

export interface Publication {
    title: string;
    authors: string[];
    boldAuthors: string[];
    journal: string;
    date: string;
    doi: string;
    volume?: string;
    issue?: string;
    pages?: string;
    note?: string;
}

export interface MediaItem {
    title: string;
    publisher: string;
    date: string;
    link: string;
}

export interface Publications {
    title: string;
    items: Publication[];
}

export interface Media {
    title: string;
    items: MediaItem[];
}

export interface BlogContextInterface {
    top: Top;
    publications: Publications;
    media: Media;
}

const BlogContext = createContext<BlogContextInterface | null>(null);

export const BlogProvider: FC<any> = ({ children }) => {
  const top: Top = data.top
  const publications: Publications = data.publications
  const media: Media = data.media

  return (
    <BlogContext.Provider value={{ top, publications, media }}>
      {children}
    </BlogContext.Provider>
  )
}

export default BlogContext
